import { FC } from 'react';
import {
    ResponsiveContainer,
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
} from 'recharts';

export interface BarSeries {
    dataKey: string;
    name: string;
    color: string;
    stackId?: string;
}

interface Props {
    data: Record<string, unknown>[];
    series: BarSeries[];
    xAxisKey: string;
    height?: number;
}

export const StatsBarChart: FC<Props> = ({ data, series, xAxisKey, height = 300 }) => {
    return (
        <ResponsiveContainer width="100%" height={height}>
            <BarChart data={data} margin={{ top: 5, right: 20, left: 0, bottom: 5 }}>
                <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
                <XAxis
                    dataKey={xAxisKey}
                    tick={{ fontSize: 12, fill: '#64748b' }}
                    tickLine={false}
                    axisLine={{ stroke: '#e2e8f0' }}
                />
                <YAxis
                    tick={{ fontSize: 12, fill: '#64748b' }}
                    tickLine={false}
                    axisLine={false}
                />
                <Tooltip
                    contentStyle={{
                        borderRadius: 8,
                        border: '1px solid #e2e8f0',
                        boxShadow: '0 4px 6px -1px rgba(0,0,0,0.1)',
                        fontSize: 13,
                    }}
                />
                <Legend wrapperStyle={{ fontSize: 12 }} />
                {series.map((s) => (
                    <Bar
                        key={s.dataKey}
                        dataKey={s.dataKey}
                        name={s.name}
                        fill={s.color}
                        stackId={s.stackId}
                        radius={s.stackId ? undefined : [4, 4, 0, 0]}
                    />
                ))}
            </BarChart>
        </ResponsiveContainer>
    );
};
